import atoms from "../../../atoms";
import {
    findConstantLabel,
    priceTagFormatter,
} from "../../../../constants/utils";
import moment from "moment";
import constant from "../../../../constants/constant";
import { MovementCancelledProps, TCancelledData } from "./interface";

const { Search, Table, Pagination, CustomImages } = atoms;
const Index = ({
    setSearch,
    cancelledListing,
    setLimitPerPage,
    setCurrentPage,
    currentPage,
    limit,
}: MovementCancelledProps) => {
    const columns = [
        {
            name: "Product ID",
            selector: (row: TCancelledData) => row?.product?.product_id_display || "-",
        },
        {
            name: "Movement ID",
            selector: (row: TCancelledData) => row?.procurement?.procurement_display_id || "-",
        },
        {
            name: "Product Type / Frame /Glass Size/Power",
            selector: (row: TCancelledData) =>
                `${row?.product?.product_type?.name}
         ${row?.product?.rim_type
                    ? findConstantLabel(
                        constant?.PRODUCT_RIM_TYPE,
                        row?.product?.rim_type
                    )
                    : ""
                }
         ${row?.product?.glass_size}`,
        },
        {
            name: "SRP",
            selector: (row: TCancelledData) => priceTagFormatter(row?.product?.product_srp) || "-",
        },
        {
            name: "Landing Cost",
            selector: (row: TCancelledData) => priceTagFormatter(row?.landing_cost ) || "-",
        },
        {
            name: "Date Time",
            selector: (row: TCancelledData) =>
                `${row?.createdAt
                    ? moment(row?.updatedAt).format("DD/MM/YYYY , H:mm:ss")
                    : "--"
                }`,
            sortable: true,
        },
        {
            name: "Cover Photo",
            cell: (row: any) => (
                <CustomImages
                    src={row?.product?.images?.length > 0 && row?.product?.images[0]}
                    imageHeight={'50px'}
                />
            ),
            center: true,
        },
        {
            name: "Requested Store Name",
            selector: (row: any) => row?.requested_store?.store_location || "-",
            minWidth: "200px",
        },
        {
            name: "Cancelled by Store",
            selector: (row: any) =>
                row?.user?.username ? row?.user?.username : " - ",
        },
        {
            name: "Order ID/Warranty Claim ID",
            selector: (row: any) =>
                row?.order?.order_id_display
                    ? row?.order?.order_id_display
                    : row?.warranty_claimed_product?.claim_id,
        },
        { name: "Status", selector: (row: any) => row.status },
    ];
    return (
        <div>
            <div className="row align-items-center">
                <div className="col-6">
                    <Search
                        searchCallBack={(e: string) => setSearch(e)}
                    />
                </div>
            </div>
            <div>
                <Table
                    AdditionalClassName="add-invertory-table data-table-container"
                    columns={columns}
                    data={cancelledListing?.data?.map((item) => {
                        return {
                            ...item,
                            status:
                                item.status === constant.MOVEMENT_STATUS.DELIVERED ? (
                                    <div className="background-light-green border-product-radius">
                                        <p className="color-green m-1 p-1">{"Delivered"}</p>
                                    </div>
                                ) : item.status === constant.MOVEMENT_STATUS.DELIVER ? (
                                    <div className="background-light-red border-product-radius">
                                        <p className="color-red m-1 p-1">{"To be Delivered"}</p>
                                    </div>
                                ) : (
                                    ""
                                ),
                        };
                    })}
                />
            </div>
            <div>
                <Pagination
                    totalCount={cancelledListing?.count}
                    currentPage={currentPage}
                    totalPages={cancelledListing?.totalPages}
                    onChangePage={(page: any) => setCurrentPage(page)}
                    setLimit={(e: number) => setLimitPerPage(e)}
                    limit={limit}
                />
            </div>
        </div>
    );
};

export default Index;
